import { render, staticRenderFns } from "./info_field.vue?vue&type=template&id=3b441fc8&scoped=true&"
import script from "./info_field.vue?vue&type=script&lang=js&"
export * from "./info_field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b441fc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b441fc8')) {
      api.createRecord('3b441fc8', component.options)
    } else {
      api.reload('3b441fc8', component.options)
    }
    module.hot.accept("./info_field.vue?vue&type=template&id=3b441fc8&scoped=true&", function () {
      api.rerender('3b441fc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/sys/info_field.vue"
export default component.exports